import { FunctionComponent, useContext } from 'react';

import cn from 'classnames';

import { ClientCard, ClientSuggest } from 'components';
import { LocalizationContext } from 'localization';

import s from './ClientSearch.module.scss';
import { IUserSearchProps } from './interfaces';

export const ClientSearch: FunctionComponent<IUserSearchProps> = ({
  className = '',
  style,
  chosenClientUUID,
  setChosenClientUUID,
  disabled,
  filterClientsFn,
  openComment,
  notShowButtonDeposit,
  setIsDepositOpen,
  setIsDefaultClient,
  onFocus,
  setIsRoleClient,
  withReplenishment,
}) => {
  const { t } = useContext(LocalizationContext);
  return (
    <div style={style} className={cn(s.root, className)}>
      {chosenClientUUID ? (
        <ClientCard
          close={disabled ? undefined : () => setChosenClientUUID(null)}
          clientUUID={chosenClientUUID}
          openComment={openComment}
          notShowButtonDeposit={notShowButtonDeposit}
          setIsDepositOpen={setIsDepositOpen}
          setIsDefaultClient={setIsDefaultClient}
          setIsRoleClient={setIsRoleClient}
        />
      ) : (
        <div>
          <ClientSuggest
            value={chosenClientUUID}
            onChange={setChosenClientUUID}
            filterClientsFn={filterClientsFn}
            disabled={disabled}
            onFocus={onFocus}
            withReplenishment={withReplenishment}
            setIsDefaultClient={setIsDefaultClient}
            setDepositOpen={setIsDepositOpen}
          />
          <div className={s['helper-text']}>{t('clients.search.help')}</div>
        </div>
      )}
    </div>
  );
};
